import { eV1Protocol, eV1HostWithPort } from './hosts.js';

export const dynamicImport = async (fileName: string): Promise<unknown> => {
  return import(
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    /* webpackIgnore: true */ `${eV1Protocol()}//${eV1HostWithPort()}/assets/external/${fileName}`
  );
};
